module.exports = __webpack_public_path__ + "static/img/1-2.03785db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/1-2.png
// module id = F8ak
// module chunks = 0